import { render, staticRenderFns } from "./index-vxe.vue?vue&type=template&id=97747e3a&scoped=true"
import script from "./index-vxe.vue?vue&type=script&lang=js"
export * from "./index-vxe.vue?vue&type=script&lang=js"
import style0 from "./index-vxe.vue?vue&type=style&index=0&id=97747e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97747e3a",
  null
  
)

export default component.exports